import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutOverview from "./sections/AboutOverview";
import ServicesOverview from "./sections/ServicesOverview";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutOverview />
      <ServicesOverview />
      <CallToAction />
      <Footer />
    </div>;
}